import { trim } from 'lodash';

import { placeholderEmailRegex } from 'common/constants/regex';

// The email and phone one partner notifies the patient on, for the Contact Details table. A value
// the partner lacks (a placeholder email counts as lacking) is the patient's default only while
// the default-contact switch is on, as the backend falls back; otherwise the partner's entry shows
// as stored, its placeholder email included.
const choosePatientContactForPartner = ({ patient, partnerContact, isDefaultContactShown }) => {
  const hasOwnEmail = !!partnerContact.email && !partnerContact.hasPlaceholderEmail;
  const hasOwnPhone = !!partnerContact.phoneNumber;
  const isDefaultEmailShown = !hasOwnEmail && !!isDefaultContactShown && !!patient?.email;
  const isDefaultPhoneShown = !hasOwnPhone && !!isDefaultContactShown && !!patient?.mobilePhone;

  return {
    email: isDefaultEmailShown ? patient.email : partnerContact.email,
    phoneNumber: isDefaultPhoneShown ? patient.mobilePhone : partnerContact.phoneNumber,
    isDefaultEmailShown,
    isDefaultPhoneShown,
    isPlaceholderEmailShown: isDefaultEmailShown
      ? placeholderEmailRegex.test(trim(patient.email))
      : !!partnerContact.hasPlaceholderEmail,
  };
};

export default choosePatientContactForPartner;
